import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { downloadGiftCardCsv } from '../actions';
import { getShop } from '../../../auth/selectors';
import GiftCardsDownload from '../components/GiftCardsDownload';

const GiftCardsDownloadContainer = compose(
  connect(state => ({
    shopId: getShop(state),
  })),
  withHandlers({
    onClick: props => () => downloadGiftCardCsv(props.shopId),
  }),
)(GiftCardsDownload);

export default GiftCardsDownloadContainer;
